module.exports = __webpack_public_path__ + "img/ima-logo-green.131f06e2.svg";